import React from 'react'
import { isEmpty, isNumber } from 'lodash-es'

import { IContestEntry } from 'protos'

import Rank from 'components/Rank'
import EventPrize from 'components/EventPrize'

import EventRankingItemDeltaIcon from './EventRankingItemDeltaIcon'

interface Props {
  rank?: IContestEntry['rank']
  prize?: IContestEntry['prize']
  rankDelta?: IContestEntry['rankDelta']
}

const EventRankingItemSubtitle: React.SFC<Props> = ({ rank, prize, rankDelta }) => (
  <>
    {isNumber(rankDelta) && rankDelta !== 0 && (
      rankDelta > 0
        ? <><EventRankingItemDeltaIcon direction="up" color="primary" fontSize="inherit" />{` `}</>
        : <><EventRankingItemDeltaIcon direction="down" color="error" fontSize="inherit" />{` `}</>
    )}
    {rank && <Rank value={rank} />}
    {!isEmpty(prize) && <>{` (`}<EventPrize prizes={prize!} />{`)`}</>}
  </>
)

export default EventRankingItemSubtitle
